import React from 'react';
import colors from '@general/colors';

const Asterisk = () => <span style={{ color: colors.error }}>*</span>;

export default Asterisk;
